/* eslint-disable */
import { DualAxes, DualAxesConfig } from '@ant-design/charts';
import React from 'react';

type DataType = {
	date: number;
	value: number | null;
	predicted: number | null;
};

interface Props {
	data: DataType[];
}

const UsageHistoryChart: React.FC<Props> = ({ data }) => {
	function formatDateWithLineBreak(milliseconds: number) {
		const date = new Date(milliseconds);
		const options: Intl.DateTimeFormatOptions = {
			month: 'short',
			day: 'numeric',
		};
		const formattedDate = date.toLocaleDateString('en-US', options);
		const year = date.getFullYear();
		return `${formattedDate}\n${year}`;
	}

	const config: DualAxesConfig = {
		data,
		xField: 'date',
		axis: {
			x: {
				labelFormatter: (datum: any) => formatDateWithLineBreak(datum),
			},
		},
		// scale: {
		// 	x: {
		// 		domain: [1700870400000, 1721865600000],
		// 	},
		// 	y: {
		// 		independent: false,
		// 		key: 'sameKey',
		// 		domain: [0, 19000],
		// 	},
		// },
		tooltip: {
			title: 'Usage',
			items: [
			  (item) => ({
				name: formatDateWithLineBreak(item.date),
				value: item.value,
			  }),
			],
		  },
		children: [
			{
				type: 'line',
				yField: 'value',
				colorField: '#5B5BE7',
				style: {
					lineWidth: 3,
				},
			},
			{
				type: 'line',
				yField: 'predicted',
				style: {
					lineDash: [8, 8],
					stroke: '#5B5BE7',
					lineWidth: 3,
				},
			},
		],
	};
	return (
		<div className="max-w-6xl">
			<h2 className="mt-10 mb-4 text-base font-medium">Usage history</h2>
			<DualAxes {...config} />
		</div>
	);
};

export default UsageHistoryChart;
